import { render, staticRenderFns } from "./QuestionLock.vue?vue&type=template&id=cdddf194"
import script from "./QuestionLock.vue?vue&type=script&lang=js"
export * from "./QuestionLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports